var $2ac19a654f19cde2$exports = {};
$2ac19a654f19cde2$exports = {
    "loading": `\u{12E}keliama...`,
    "placeholder": `Pasirinkite\u{2026}`
};


export {$2ac19a654f19cde2$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
